import { __values } from "tslib";
import { CustomFilterType } from '../models/Filters';
export function getFilteredTabId(tabId) {
    var e_1, _a;
    try {
        for (var _b = __values([
            CustomFilterType.OwnedBy,
            CustomFilterType.SharedBy,
            CustomFilterType.Tag,
            CustomFilterType.Tagv2,
        ]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var filterType = _c.value;
            if (tabId.indexOf(filterType) === 0) {
                return filterType;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return tabId;
}
//# sourceMappingURL=getFilteredTabId.js.map